(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
    const initializeCartSection = (cartForm) => {
      if (!cartForm || cartForm.dataset.jsInitialized === 'true') return;
      cartForm.dataset.jsInitialized = 'true';
      let cartUpdateTimeout = null;

      const submitCartUpdate = () => {
        window.clearTimeout(cartUpdateTimeout);
        cartUpdateTimeout = window.setTimeout(() => {
          if (typeof cartForm.requestSubmit === 'function') {
            cartForm.requestSubmit();
          } else {
            cartForm.submit();
          }
        }, 180);
      };

      cartForm.querySelectorAll('[data-cart-qty-step]').forEach((button) => {
        button.addEventListener('click', () => {
          const input = button.parentElement.querySelector('input');
          if (!input) return;
          const next = Math.max(0, Number(input.value || 0) + Number(button.dataset.cartQtyStep));
          input.value = next;
          submitCartUpdate();
        });
      });

      cartForm.querySelectorAll('.cart-item__quantity input').forEach((input) => {
        input.addEventListener('change', () => {
          input.value = Math.max(0, Number(input.value || 0));
          submitCartUpdate();
        });
      });

      cartForm.querySelectorAll('[data-remove-bundle]').forEach((button) => {
        button.addEventListener('click', () => {
          const bundleId = button.dataset.removeBundle;
          if (!bundleId) return;

          cartForm.querySelectorAll(`[data-bundle-line][data-bundle-id="${bundleId}"]`).forEach((input) => {
            input.value = 0;
          });

          submitCartUpdate();
        });
      });
    };

    const initializeCartSections = () => {
      document.querySelectorAll('.cart-page').forEach(initializeCartSection);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeCartSections, { once: true });
    } else {
      initializeCartSections();
    }
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (() => {
    const responsiveBreakpoint = window.matchMedia('(max-width: 989px)');

    const syncFilterPanel = (panel) => {
      const viewport = responsiveBreakpoint.matches ? 'compact' : 'desktop';

      if (panel.dataset.filterViewport === viewport) return;

      panel.toggleAttribute('open', viewport === 'desktop');
      panel.dataset.filterViewport = viewport;
    };

    const syncFilterPanels = (root = document) => {
      root.querySelectorAll('[data-responsive-filter-panel]').forEach(syncFilterPanel);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => syncFilterPanels(), { once: true });
    } else {
      syncFilterPanels();
    }

    responsiveBreakpoint.addEventListener('change', () => syncFilterPanels());
    document.addEventListener('shopify:section:load', (event) => syncFilterPanels(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
    const initializeProductSection = (productSection) => {
      if (!productSection || productSection.dataset.jsInitialized === 'true') return;
      productSection.dataset.jsInitialized = 'true';

      const optionSelects = Array.from(productSection.querySelectorAll('[data-option-select]'));
      const optionButtons = Array.from(productSection.querySelectorAll('[data-option-button]'));
      const quantityInput = productSection.querySelector('[data-product-quantity]');
      const mediaItems = Array.from(productSection.querySelectorAll('[data-product-media]'));
      const mediaTriggers = Array.from(productSection.querySelectorAll('[data-media-trigger]'));
      const lightbox = productSection.querySelector('[data-product-lightbox]');
      const lightboxOpeners = Array.from(productSection.querySelectorAll('[data-lightbox-open]'));
      const lightboxSlides = lightbox ? Array.from(lightbox.querySelectorAll('[data-lightbox-slide]')) : [];
      const lightboxThumbs = lightbox ? Array.from(lightbox.querySelectorAll('[data-lightbox-thumb]')) : [];
      const lightboxStage = lightbox?.querySelector('[data-lightbox-stage]');
      const lightboxClose = lightbox?.querySelector('[data-lightbox-close]');
      const lightboxPrevious = lightbox?.querySelector('[data-lightbox-previous]');
      const lightboxNext = lightbox?.querySelector('[data-lightbox-next]');
      let activeLightboxIndex = 0;
      let activeLightboxScale = 1;
      let lightboxTranslateX = 0;
      let lightboxTranslateY = 0;
      let lightboxGestureStartDistance = 0;
      let lightboxGestureStartScale = 1;
      let lightboxGestureStartTranslateX = 0;
      let lightboxGestureStartTranslateY = 0;
      let lightboxSinglePointerId = null;
      let lightboxSingleStartX = 0;
      let lightboxSingleStartY = 0;
      let lightboxSingleStartTranslateX = 0;
      let lightboxSingleStartTranslateY = 0;
      const lightboxPointers = new Map();
      let focusedBeforeLightbox = null;

      const showMedia = (id) => {
        mediaItems.forEach((item) => item.classList.toggle('is-active', item.dataset.productMedia === id));
        mediaTriggers.forEach((trigger) => trigger.classList.toggle('is-active', trigger.dataset.mediaTrigger === id));
      };

      const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

      const getActiveLightboxImage = () => lightboxSlides[activeLightboxIndex]?.querySelector('.product-lightbox__image');

      const constrainLightboxPan = () => {
        if (!lightboxStage || activeLightboxScale <= 1) {
          lightboxTranslateX = 0;
          lightboxTranslateY = 0;
          return;
        }

        const maxTranslateX = (lightboxStage.clientWidth * (activeLightboxScale - 1)) / 2;
        const maxTranslateY = (lightboxStage.clientHeight * (activeLightboxScale - 1)) / 2;
        lightboxTranslateX = clamp(lightboxTranslateX, -maxTranslateX, maxTranslateX);
        lightboxTranslateY = clamp(lightboxTranslateY, -maxTranslateY, maxTranslateY);
      };

      const applyLightboxTransform = () => {
        const image = getActiveLightboxImage();
        if (!image) return;

        constrainLightboxPan();

        if (activeLightboxScale <= 1) {
          image.style.transform = '';
          return;
        }

        image.style.transform = `translate3d(${lightboxTranslateX}px, ${lightboxTranslateY}px, 0) scale(${activeLightboxScale})`;
      };

      const resetLightboxZoom = () => {
        activeLightboxScale = 1;
        lightboxTranslateX = 0;
        lightboxTranslateY = 0;
        lightboxPointers.clear();
        lightboxSlides.forEach((slide) => {
          const image = slide.querySelector('.product-lightbox__image');
          if (image) image.style.transform = '';
        });
      };

      const getLightboxPointerDistance = () => {
        const pointers = Array.from(lightboxPointers.values());
        if (pointers.length < 2) return 0;

        return Math.hypot(pointers[0].x - pointers[1].x, pointers[0].y - pointers[1].y);
      };

      const setLightboxSlide = (index) => {
        if (!lightboxSlides.length) return;

        resetLightboxZoom();
        activeLightboxIndex = (index + lightboxSlides.length) % lightboxSlides.length;
        const activeSlide = lightboxSlides[activeLightboxIndex];
        const activeMediaId = activeSlide.dataset.lightboxSlide;

        lightboxSlides.forEach((slide) => {
          const isActive = slide === activeSlide;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });

        lightboxThumbs.forEach((thumb) => {
          const isActive = thumb.dataset.lightboxThumb === activeMediaId;
          thumb.classList.toggle('is-active', isActive);
          thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
      };

      const getLightboxIndex = (mediaId) => {
        const index = lightboxSlides.findIndex((slide) => slide.dataset.lightboxSlide === mediaId);
        return index >= 0 ? index : 0;
      };

      const openLightbox = (mediaId) => {
        if (!lightbox || !lightboxSlides.length) return;

        focusedBeforeLightbox = document.activeElement;
        setLightboxSlide(getLightboxIndex(mediaId));
        lightbox.classList.add('is-open');
        lightbox.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('product-lightbox-open');
        lightboxClose?.focus({ preventScroll: true });
      };

      const closeLightbox = () => {
        if (!lightbox) return;

        lightbox.classList.remove('is-open');
        lightbox.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('product-lightbox-open');
        resetLightboxZoom();
        focusedBeforeLightbox?.focus?.({ preventScroll: true });
      };

      const showPreviousLightboxSlide = () => setLightboxSlide(activeLightboxIndex - 1);
      const showNextLightboxSlide = () => setLightboxSlide(activeLightboxIndex + 1);

      const navigateToOptionUrl = (url) => {
        if (!url) return;

        const nextUrl = new URL(url, window.location.origin);
        if (nextUrl.pathname === window.location.pathname && nextUrl.search === window.location.search && nextUrl.hash === window.location.hash) {
          return;
        }

        window.location.assign(nextUrl.toString());
      };

      mediaTriggers.forEach((trigger) => {
        trigger.addEventListener('click', () => showMedia(trigger.dataset.mediaTrigger));
      });

      lightboxOpeners.forEach((button) => {
        button.addEventListener('click', () => openLightbox(button.dataset.lightboxOpen));
      });

      lightboxClose?.addEventListener('click', closeLightbox);
      lightboxPrevious?.addEventListener('click', showPreviousLightboxSlide);
      lightboxNext?.addEventListener('click', showNextLightboxSlide);

      lightboxThumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => setLightboxSlide(getLightboxIndex(thumb.dataset.lightboxThumb)));
      });

      lightbox?.addEventListener('click', (event) => {
        if (event.target === lightbox) closeLightbox();
      });

      lightboxStage?.addEventListener('pointerdown', (event) => {
        lightboxPointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
        lightboxStage.setPointerCapture(event.pointerId);

        if (lightboxPointers.size === 1) {
          lightboxSinglePointerId = event.pointerId;
          lightboxSingleStartX = event.clientX;
          lightboxSingleStartY = event.clientY;
          lightboxSingleStartTranslateX = lightboxTranslateX;
          lightboxSingleStartTranslateY = lightboxTranslateY;
        } else if (lightboxPointers.size === 2) {
          lightboxGestureStartDistance = getLightboxPointerDistance();
          lightboxGestureStartScale = activeLightboxScale;
          lightboxGestureStartTranslateX = lightboxTranslateX;
          lightboxGestureStartTranslateY = lightboxTranslateY;
        }
      });

      lightboxStage?.addEventListener('pointermove', (event) => {
        if (!lightboxPointers.has(event.pointerId)) return;

        lightboxPointers.set(event.pointerId, { x: event.clientX, y: event.clientY });

        if (lightboxPointers.size >= 2 && lightboxGestureStartDistance > 0) {
          const nextDistance = getLightboxPointerDistance();
          activeLightboxScale = clamp((nextDistance / lightboxGestureStartDistance) * lightboxGestureStartScale, 1, 3);
          lightboxTranslateX = lightboxGestureStartTranslateX;
          lightboxTranslateY = lightboxGestureStartTranslateY;
          applyLightboxTransform();
          return;
        }

        if (event.pointerId !== lightboxSinglePointerId || lightboxPointers.size !== 1 || activeLightboxScale <= 1) return;

        lightboxTranslateX = lightboxSingleStartTranslateX + event.clientX - lightboxSingleStartX;
        lightboxTranslateY = lightboxSingleStartTranslateY + event.clientY - lightboxSingleStartY;
        applyLightboxTransform();
      });

      lightboxStage?.addEventListener('pointerup', (event) => {
        if (!lightboxPointers.has(event.pointerId)) return;

        const previousPointerCount = lightboxPointers.size;
        const deltaX = event.clientX - lightboxSingleStartX;
        const deltaY = event.clientY - lightboxSingleStartY;
        lightboxPointers.delete(event.pointerId);

        if (activeLightboxScale < 1.04) {
          activeLightboxScale = 1;
          lightboxTranslateX = 0;
          lightboxTranslateY = 0;
          applyLightboxTransform();
        }

        if (
          previousPointerCount === 1 &&
          lightboxSlides.length > 1 &&
          activeLightboxScale <= 1 &&
          Math.abs(deltaX) > 48 &&
          Math.abs(deltaX) > Math.abs(deltaY)
        ) {
          if (deltaX < 0) {
            showNextLightboxSlide();
          } else {
            showPreviousLightboxSlide();
          }
        }

        if (lightboxPointers.size === 1) {
          const remainingPointer = Array.from(lightboxPointers.entries())[0];
          lightboxSinglePointerId = remainingPointer[0];
          lightboxSingleStartX = remainingPointer[1].x;
          lightboxSingleStartY = remainingPointer[1].y;
          lightboxSingleStartTranslateX = lightboxTranslateX;
          lightboxSingleStartTranslateY = lightboxTranslateY;
        } else {
          lightboxSinglePointerId = null;
          lightboxGestureStartDistance = 0;
        }
      });

      lightboxStage?.addEventListener('pointercancel', (event) => {
        lightboxPointers.delete(event.pointerId);
        lightboxSinglePointerId = null;
        lightboxGestureStartDistance = 0;
      });

      document.addEventListener('keydown', (event) => {
        if (!lightbox?.classList.contains('is-open')) return;

        if (event.key === 'Escape') {
          closeLightbox();
        } else if (event.key === 'ArrowLeft' && lightboxSlides.length > 1) {
          showPreviousLightboxSlide();
        } else if (event.key === 'ArrowRight' && lightboxSlides.length > 1) {
          showNextLightboxSlide();
        }
      });

      optionButtons.forEach((button) => {
        button.addEventListener('click', () => {
          if (button.disabled) return;
          navigateToOptionUrl(button.dataset.optionUrl);
        });
      });

      optionSelects.forEach((select) => {
        select.addEventListener('change', () => {
          const selectedOption = select.selectedOptions[0];
          navigateToOptionUrl(selectedOption?.dataset.optionUrl);
        });
      });

      productSection.querySelectorAll('[data-quantity-step]').forEach((button) => {
        button.addEventListener('click', () => {
          if (!quantityInput) return;
          const nextValue = Math.max(1, Number(quantityInput.value || 1) + Number(button.dataset.quantityStep));
          quantityInput.value = nextValue;
        });
      });
    };

    const initializeProductSections = () => {
      document.querySelectorAll('.product-page').forEach(initializeProductSection);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeProductSections, { once: true });
    } else {
      initializeProductSections();
    }
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-form"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const form = document.getElementById('QuoteRequestForm');
    if (!form) return;

    const params = new URLSearchParams(window.location.search);
    const productField = form.querySelector('[data-quote-product]');
    const productUrlField = form.querySelector('[data-quote-url]');
    const messageField = form.querySelector('[data-quote-message]');
    const product = params.get('product');
    const productUrl = params.get('product_url');
    const variant = params.get('variant');

    if (productField && product && !productField.value) {
      productField.value = variant ? `${product} (${variant})` : product;
    }

    if (productUrlField && productUrl && !productUrlField.value) {
      productUrlField.value = productUrl;
    }

    if (messageField && product && !messageField.value.trim()) {
      messageField.value = `Projektkontekst:\nProdukt: ${variant ? `${product} (${variant})` : product}${productUrl ? `\nProdukt-URL: ${productUrl}` : ''}\n\nDetaljer:\n`;
      messageField.setSelectionRange(messageField.value.length, messageField.value.length);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  const initializeProductRecommendations = (container) => {
    if (!container || container.dataset.recommendationsInitialized === 'true') return;

    const recommendationsUrl = container.dataset.recommendationsUrl;
    if (!recommendationsUrl) return;

    container.dataset.recommendationsInitialized = 'true';

    const loadRecommendations = async () => {
      try {
        const response = await fetch(recommendationsUrl);
        if (!response.ok) throw new Error(`Product recommendations request failed: ${response.status}`);

        const responseText = await response.text();
        const responseDocument = new DOMParser().parseFromString(responseText, 'text/html');
        const renderedRecommendations = responseDocument.querySelector('[data-product-recommendations]');

        if (renderedRecommendations?.innerHTML.trim()) {
          container.innerHTML = renderedRecommendations.innerHTML;
        } else {
          container.hidden = true;
        }
      } catch (error) {
        container.hidden = true;
        console.error(error);
      }
    };

    if (!('IntersectionObserver' in window)) {
      loadRecommendations();
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0].isIntersecting) return;

        observer.disconnect();
        loadRecommendations();
      },
      { rootMargin: '0px 0px 300px 0px' }
    );

    observer.observe(container);
  };

  const initializeAllProductRecommendations = (scope = document) => {
    scope.querySelectorAll('[data-product-recommendations]').forEach(initializeProductRecommendations);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAllProductRecommendations(), { once: true });
  } else {
    initializeAllProductRecommendations();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAllProductRecommendations(event.target));

  } catch(e) { console.error(e); }
})();
})();
